/**
 * Featured Project block — dialog open/close behaviour.
 *
 * Uses the native <dialog> element. Escape key and ::backdrop click are
 * handled natively. We add scroll-lock, focus management, and the close
 * button handler on top.
 */

document.querySelectorAll('.wp-block-pulp-featured-project').forEach((block) => {
    const trigger = block.querySelector('.block-trigger');
    const dialog  = block.querySelector('.featured-project-dialog');

    if (! trigger || ! dialog) {
        return;
    }

    const closeBtn = dialog.querySelector('.dialog-close');
    const inner    = dialog.querySelector('.dialog-inner');

    function openDialog() {
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        inner.scrollTop = 0;
        closeBtn?.focus();
    }

    function closeDialog() {
        dialog.close();
    }

    // Native close event fires on both dialog.close() and Escape key press.
    dialog.addEventListener('close', () => {
        document.body.style.overflow = '';
        trigger.focus();
    });

    trigger.addEventListener('click', openDialog);
    closeBtn?.addEventListener('click', closeDialog);

    // Close when clicking the backdrop (the dialog element itself, outside the inner panel).
    dialog.addEventListener('click', (e) => {
        if (! inner.contains(e.target)) {
            closeDialog();
        }
    });
});
